module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_tips"
  }, [(_vm.type == 'loading') ? [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  }), _vm._v("\n\t\t页面加载中...\n\t")] : (404) ? [_c('h1', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("404")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3f7b0601","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tips.vue
// module id = 188
// module chunks = 2